type SortArrowsIconProps = {
    direction?: 'up' | 'down';
};

const SORT_ARROWS_PATH =
    'M11.3327 2C10.9645 2 10.666 2.29848 10.666 2.66667V11.7239L9.13742 10.1953C8.87707 9.93491 8.45496 9.93491 8.19461 10.1953C7.93426 10.4556 7.93426 10.8777 8.19461 11.1381L10.8613 13.8047C11.1216 14.0651 11.5437 14.0651 11.8041 13.8047L14.4708 11.1381C14.7311 10.8777 14.7311 10.4556 14.4708 10.1953C14.2104 9.93491 13.7883 9.93491 13.5279 10.1953L11.9993 11.7239V2.66667C11.9993 2.29848 11.7009 2 11.3327 2ZM4.66602 2C4.29783 2 3.99935 2.29848 3.99935 2.66667V8.39052L2.47075 6.86193C2.2104 6.60158 1.7883 6.60158 1.52794 6.86193C1.2676 7.12228 1.2676 7.54439 1.52794 7.80474L4.19461 10.4714C4.45496 10.7318 4.87707 10.7318 5.13742 10.4714L7.80409 7.80474C8.06444 7.54439 8.06444 7.12228 7.80409 6.86193C7.54374 6.60158 7.12163 6.60158 6.86128 6.86193L5.33268 8.39052V2.66667C5.33268 2.29848 5.03421 2 4.66602 2Z';

const SortArrowsIcon = ({ direction = 'down' }: SortArrowsIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <g transform={direction === 'up' ? 'scale(1 -1) translate(0 -16)' : undefined}>
            <path fillRule="evenodd" clipRule="evenodd" d={SORT_ARROWS_PATH} fill="currentColor" />
        </g>
    </svg>
);

export default SortArrowsIcon;
